const publicLandingEs = {
  public: {
    language: {
      aria: 'Elegir el idioma de la interfaz',
      mobile_label: 'Idioma',
    },
    nav: {
      home_aria: 'Inicio de UpyaChat',
      primary_aria: 'Navegacion principal',
      features: 'Funciones',
      pricing: 'Precios',
      finance: 'UpyaChat Finance',
      blog: 'Blog',
      login: 'Iniciar sesion',
      try_for_free: 'Probar gratis',
      menu_toggle: 'Abrir el menu de navegacion',
    },
    footer: {
      aria: 'Pie de pagina',
      terms: 'Terminos',
      privacy: 'Privacidad',
      copy: '© 2026 UpyaChat · Las recomendaciones proporcionadas tienen como objetivo apoyar la toma de decisiones y no sustituyen la experiencia humana.',
    },
    blog: {
      seo_title: 'Blog de UpyaChat',
      seo_description: 'Artículos de campo sobre salud de los cultivos, interpretación del suelo y decisiones agrícolas para agricultores, asesores y prestamistas.',
      label: 'Blog de UpyaChat',
      index_title: 'Artículos prácticos para las decisiones sobre cultivos, suelo y explotación',
      read_article: 'Leer el artículo',
      back_to_blog: 'Volver al blog',
      cta_title: '¿Necesitas una respuesta para tu propio caso?',
      cta_body: 'Abre UpyaChat, describe tu problema de campo o sube tu documento y continúa el análisis dentro del producto.',
      cta_button: 'Acceder a UpyaChat',
    },
  },
  landing: {
    seo: {
      title: 'UpyaChat | Asesoramiento agrícola experto para cada parcela',
      description:
        'Haz una pregunta, sube una foto o comparte un informe de suelo. UpyaChat ofrece a agricultores y asesores respuestas agronómicas claras en segundos.',
    },
    hero: {
      badge: 'CULTIVAR LA RESILIENCIA',
      title_line1: 'IA DE CAMPO PARA',
      title_line2: 'UNA AGRICULTURA REGENERATIVA',
      subtitle:
        'Asesoramiento agroecológico para el campo: convierte cada observación en una acción práctica. Toma una foto, envía un mensaje de voz, haz una pregunta o sube un informe de suelo. UpyaChat ofrece evaluaciones específicas para cada cultivo y recomendaciones agroecológicas basadas en la ciencia, adaptadas a los suelos, el clima y las limitaciones de tu explotación.',
      subtitle_lead:
        'Asesoramiento agroecológico para el campo: convierte cada observación en una acción práctica.',
      subtitle_body:
        'Toma una foto, envía un mensaje de voz, haz una pregunta o sube un informe de suelo. UpyaChat ofrece evaluaciones específicas para cada cultivo y recomendaciones agroecológicas basadas en la ciencia, adaptadas a los suelos, el clima y las limitaciones de tu explotación.',
      cta: 'Empezar gratis',
      proof_prefix:
        'En la que confían agricultores, asesores agrícolas y organizaciones que apoyan la transición agroecológica en',
      proof_highlight: '15+ países',
      image_alt: 'Parcela agrícola',
      chat_question: '¿Qué asociaciones de cultivos funcionan mejor con el café?',
      chat_answer:
        'Las leguminosas como los frijoles fijan nitrógeno en el suelo, mientras que los bananos aportan sombra y acolchado esenciales para los cafetos...',
      scroll: 'desplázate',
    },
    marquee: {
      label: 'Preguntas realizadas cada día ->',
    },
    resilience: {
      tag: 'MEJOR AGRICULTURA, MAYOR RESILIENCIA',
      title: 'Convierte cada decisión en parte de un sistema agrícola más resiliente',
      description:
        'UpyaChat ayuda a los agricultores a resolver los problemas de hoy mientras mejora progresivamente el funcionamiento de su explotación: reduce los insumos innecesarios, refuerza los procesos naturales y adapta las prácticas a las condiciones climáticas cambiantes.',
    },
    questions: [
      'Mi maíz se sembró con 10 días de retraso. ¿Cómo debería adaptar el itinerario técnico?',
      'La temporada pasada planté caupí después del maíz. ¿Qué debería plantar después para mejorar la fertilidad del suelo?',
      'Tengo 1 ha de cacahuete y no tengo acceso al riego. ¿Cómo debería gestionar el estrés hídrico?',
      'Mi maíz de 4 semanas tiene las hojas amarillas después de lluvias intensas. ¿Cuál es la causa probable?',
      'Después de dos temporadas consecutivas de mijo, ¿qué cultivo restauraría mejor la fertilidad del suelo?',
      'Las lluvias se han detenido durante 15 días mientras el maíz estaba floreciendo. ¿Qué puedo hacer para reducir las pérdidas de rendimiento?',
      'Mi campo de tomates tiene pulgones y ya apliqué neem dos veces. ¿Qué debería probar ahora?',
      'Tengo 3 ha de mandioca en un suelo degradado. ¿Qué prácticas podrían mejorar la productividad durante dos temporadas?',
      'La temporada pasada coseché 1,8 t/ha de maíz. ¿Cuáles son las principales palancas para alcanzar 3 t/ha?',
      '¿Qué rotación recomendarías para una explotación que combina sorgo, caupí y cacahuete?',
      'Un agricultor solicita un préstamo para 2 ha de trigo. ¿Es viable económicamente el plan de producción?',
      'Un cliente cosechó un 30 % menos de lo previsto la temporada pasada. ¿Cómo debería reevaluar su capacidad de reembolso?',
      'Un agricultor quiere un préstamo para implantar un sistema agroforestal. ¿Cuáles son los principales riesgos de producción y reembolso?',
    ],
    stats: {
      items: [
        { number: 0, suffix: '€', label: 'para empezar, es completamente gratis' },
        { number: 15, suffix: '+', label: 'paises donde agricultores usan UpyaChat' },
        { number: 24, suffix: '/7', label: 'disponible, todos los dias del ano' },
      ],
    },
    modes: {
      tag: 'Lo que puedes hacer con UpyaChat',
      title: '¿En qué necesitas ayuda hoy?',
      subtitle:
        'Empieza con lo que tienes: una pregunta, una foto o un documento. UpyaChat lo convierte en próximos pasos claros y prácticos.',
      items: [
        {
          label: 'Tengo una pregunta sobre mis cultivos',
          desc: 'Pregunta sobre enfermedades, prácticas, calendarios, insumos o decisiones de campo. Recibe una respuesta clara y práctica, adaptada a tu situación.',
        },
        {
          label: 'Algo va mal. Tengo una foto',
          desc: 'Toma una foto del problema. UpyaChat te ayuda a identificar la causa probable, explica los riesgos y sugiere qué hacer a continuación.',
        },
        {
          label: 'No reconozco esta planta',
          desc: 'Toma una foto. Identifica la planta, descubre si es útil, perjudicial o invasora, y entiende lo que significa para tu campo.',
        },
        {
          label: 'No entiendo mi analisis de suelo',
          desc: 'Sube tu informe de laboratorio. UpyaChat traduce los números a un lenguaje sencillo y los convierte en recomendaciones prácticas para el suelo y la fertilización.',
        },
        {
          label: 'Necesito ayuda con un prestamo agricola',
          desc: 'Evalúa los riesgos agronómicos y financieros, entiende las condiciones de reembolso y comprueba si el préstamo encaja con el ciclo del cultivo y los rendimientos previstos antes de comprometerte.',
        },
      ],
    },
    why: {
      tag: '¿En qué necesitas ayuda hoy?',
      title: 'Diseñado para la realidad del campo',
      items: [
        {
          title: 'Actúa en el momento adecuado',
          desc: 'Desde los síntomas de enfermedades y las decisiones de riego hasta la siembra, la fertilización y la gestión de cultivos, UpyaChat te ayuda a anticipar riesgos y ajustar las prácticas cuando cambian las condiciones.',
        },
        {
          title: 'Consejos que tienen en cuenta las condiciones locales',
          desc: 'UpyaChat combina los datos climáticos locales, los conocimientos agroecológicos y el contexto de tu explotación para formular recomendaciones prácticas, adaptadas a tu parcela.',
        },
        {
          title: 'Mantén tu explotación o proyecto en contexto',
          desc: 'Usa espacios de proyecto específicos para mantener juntos tus objetivos, observaciones, recomendaciones y seguimiento, mientras reservas las conversaciones individuales para las preguntas del día a día.',
        },
        {
          title: 'Obtén ayuda con un préstamo agrícola',
          desc: 'Evalúa los riesgos agronómicos y financieros, entiende las condiciones de reembolso y comprueba si el préstamo encaja con el ciclo del cultivo y los rendimientos previstos antes de comprometerte.',
        },
        {
          title: 'Diseñado para trabajar en el campo',
          desc: 'Usa UpyaChat en tu teléfono, con Internet o a través de WhatsApp, en tu propio idioma y allí donde cultives.',
        },
      ],
    },
    features: {
      tag: 'Ver en accion',
      title: 'Problemas de campo. Respuestas prácticas',
      cta: 'Probar ahora',
      items: [
        {
          title: 'Obtén orientación técnica agroecológica contextualizada',
          desc: 'Pregunta a UpyaChat sobre un cultivo, una situación de campo o un reto técnico. Recibe recomendaciones prácticas y contextualizadas, así como itinerarios técnicos agroecológicos adaptados a tu explotación, tus condiciones y tus objetivos.',
          alt: 'UpyaChat respondiendo una pregunta agrícola',
        },
        {
          title: 'Mis cultivos presentan síntomas',
          desc: 'Toma una foto del problema. UpyaChat te ayuda a identificar la causa probable, explica los riesgos y sugiere qué hacer a continuación.',
          alt: 'UpyaChat diagnosticando un cultivo a partir de una foto',
        },
        {
          title: 'No consigo entender mi informe de suelo',
          desc: 'Sube tu informe de laboratorio. UpyaChat traduce los números a un lenguaje sencillo y los convierte en recomendaciones prácticas para la gestión del suelo.',
          alt: 'UpyaChat interpretando un análisis de suelo',
        },
      ],
    },
    audience: {
      tag: 'QUIÉN USA UPYACHAT',
      title: 'Una plataforma, distintos roles, mejores decisiones en el campo',
      items: [
        {
          label: 'Agricultores',
          desc: 'Obtén respuestas prácticas a los desafíos cotidianos del campo: desde la salud de los cultivos y la gestión del suelo hasta el riego, el calendario y el uso de insumos.',
        },
        {
          label: 'Asesores agrícolas',
          desc: 'Amplía tu alcance, investiga más casos y respalda tus recomendaciones con inteligencia agronómica contextualizada.',
        },
        {
          label: 'Cooperativas y organizaciones de agricultores',
          desc: 'Ofrece a tus miembros un acceso sencillo a orientación agroecológica coherente y localizada, mientras apoyas proyectos colectivos, formación y seguimiento.',
        },
        {
          label: 'Instituciones de financiación agrícola',
          desc: 'Comprende mejor los riesgos agronómicos y climáticos, estructura la financiación en torno a los ciclos de cultivo y apoya a tus clientes con consejos prácticos durante todo el proceso del préstamo.',
        },
      ],
    },
    finance: {
      tag: 'UPYACHAT FINANCE',
      title: '¿Y si la financiación se convirtiera en un motor de transición agroecológica y resiliencia climática?',
      description:
        'UpyaChat Finance ayuda a los equipos de crédito a comprender el contexto de cada explotación, evaluar los riesgos y estructurar una financiación adaptada a las realidades agronómicas y climáticas.',
      cta: 'Probar UpyaChat Finance',
      process_label: 'Recorrido de evaluación y financiación agrícola',
      process_kicker: 'Del análisis a la acción',
      process_title: 'Decisiones de crédito conectadas con la realidad del campo',
      steps: [
        {
          title: 'Una evaluación guiada del agricultor',
          desc: 'Recoge el proyecto, la necesidad de financiación y el uso previsto de los fondos.',
        },
        {
          title: 'Un perfil agroecológico de la explotación',
          desc: 'Documenta las prácticas, los sistemas de cultivo, la trayectoria de transición y el contexto de mercado.',
        },
        {
          title: 'Una evaluación de los riesgos climáticos y agronómicos',
          desc: 'Identifica la exposición climática, los riesgos agronómicos y económicos y las limitaciones de reembolso.',
        },
        {
          title: 'Asesoramiento y financiación alineados con los cultivos',
          desc: 'Convierte el diagnóstico en recomendaciones agroecológicas y calendarios de pago alineados con el ciclo de cultivo.',
        },
      ],
      outcomes: [
        {
          title: 'Un mejor acompañamiento en el campo',
          desc: 'Perfiles agrícolas estructurados y orientación agroecológica antes y durante las visitas.',
        },
        {
          title: 'Préstamos más resilientes frente al clima',
          desc: 'Una visión más clara de la exposición climática, las palancas de resiliencia y los riesgos de reembolso.',
        },
        {
          title: 'Relaciones más sólidas entre agricultores e instituciones',
          desc: 'Financiación y asesoramiento que reflejan las realidades agrícolas y las necesidades de transición.',
        },
      ],
    },
    pricing: {
      tag: 'Precios',
      title: 'Empieza gratis. Amplía tu plan a medida que crecen tus necesidades.',
      subtitle:
        'Crea tu cuenta en segundos con tu dirección de email o número de WhatsApp. No necesitas una suscripción para empezar. Todos los planes incluyen respuestas multilingües y acceso a tu historial de conversaciones.',
      badge: 'Más popular',
      plans: [
        {
          name: 'Free',
          price: '0',
          period: '',
          tagline: 'Pruebalo, sin compromiso',
          features: [
            'Obtén consejos agroecológicos contextualizados para tus primeras preguntas',
            'Acceso limitado a todas las funciones',
            'Disponible en la aplicación web o por WhatsApp',
            'Responde en tu idioma',
          ],
          cta: 'Empezar gratis',
          highlight: false,
        },
        {
          name: 'Expert',
          price: '9.90',
          period: '/mes',
          tagline: 'Tu asistente agroecológico para el día a día',
          features: [
            'Acceso ilimitado a consultas',
            'Respuestas disponibles 24/7',
            'Consejos sobre cultivos, plagas, malas hierbas, suelos y prácticas agroecológicas',
            'Haz preguntas por texto, foto o mensaje de voz',
          ],
          cta: 'Obtener Expert',
          highlight: true,
        },
        {
          name: 'Finance',
          price: '11.90',
          period: '/mes',
          tagline: 'Para las finanzas climáticas e inclusivas',
          features: [
            'Accede a UpyaChat Finance',
            'Evalúa los riesgos agronómicos, climáticos y financieros asociados a los créditos agrícolas',
            'Estructura calendarios de pago alineados con los ciclos de cultivo',
            'Una solución diseñada para bancos, instituciones de microfinanzas y cooperativas',
          ],
          cta: 'Obtener Finance',
          highlight: false,
        },
        {
          name: 'Vision',
          price: '19.90',
          period: '/mes',
          tagline: 'Analiza tus cultivos, plantas y suelos',
          features: [
            'Todo lo de Expert',
            'Diagnóstico avanzado de cultivos a partir de fotos',
            'Identificación ilimitada de malas hierbas y plagas',
            'Interpretación ilimitada de análisis de suelo e informes de laboratorio',
          ],
          cta: 'Obtener Vision',
          highlight: false,
        },
      ],
    },
    final_cta: {
      tag: 'UpyaChat',
      title_line1: 'Cada decisión en el campo puede fortalecer',
      title_line2: 'la resiliencia.',
      subtitle:
        'Usa UpyaChat para resolver los problemas de hoy mientras mejoras progresivamente la salud del suelo, reduces la dependencia de insumos y adaptas tu sistema agrícola a la incertidumbre climática.',
      cta: 'Crear tu cuenta',
    },
  },
};

export default publicLandingEs;
